module.exports = __webpack_public_path__ + "img/learn.4dbf508d.png";